package com.partejar.app.core.format

import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlin.time.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.atStartOfDayIn
import kotlinx.datetime.toLocalDateTime
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.plus
import kotlinx.datetime.minus

fun formatBrazilianDate(value: String?): String? = value
    ?.let { runCatching { LocalDate.parse(it) }.getOrNull() }
    ?.let { date ->
        "${date.dayOfMonth.toString().padStart(2, '0')}/${date.monthNumber.toString().padStart(2, '0')}/${date.year.toString().padStart(4, '0')}"
    }

fun formatBrazilianDateTime(value: String?): String? = value
    ?.let { runCatching { LocalDateTime.parse(it) }.getOrNull() }
    ?.let { dateTime ->
        val date = formatBrazilianDate(dateTime.date.toString()) ?: return@let null
        val hour = dateTime.hour.toString().padStart(2, '0')
        val minute = dateTime.minute.toString().padStart(2, '0')
        "$date · $hour:$minute"
    }

/** Strict Brazilian input; ISO remains an internal/API representation. */
fun parseBrazilianDate(value: String): LocalDate? {
    if (!Regex("[0-9]{2}/[0-9]{2}/[0-9]{4}").matches(value)) return null
    return runCatching {
        LocalDate(value.substring(6).toInt(), value.substring(3, 5).toInt(), value.substring(0, 2).toInt())
    }.getOrNull()?.takeIf { it.year in 1..9999 }
}

/** DatePicker encodes a calendar day at UTC midnight, not in the device time zone. */
fun datePickerMillisToBrazilianDate(millis: Long): String =
    requireNotNull(formatBrazilianDate(Instant.fromEpochMilliseconds(millis).toLocalDateTime(TimeZone.UTC).date.toString()))

fun brazilianDateToDatePickerMillis(value: String): Long? =
    parseBrazilianDate(value)?.atStartOfDayIn(TimeZone.UTC)?.toEpochMilliseconds()

/** Sunday-first calendar cells; no date eligibility or clinical rules are introduced. */
internal fun calendarMonthCells(month: LocalDate): List<LocalDate?> {
    val first = LocalDate(month.year, month.monthNumber, 1)
    val offset = first.dayOfWeek.ordinal.let { (it + 1) % 7 }
    val days = first.plus(DatePeriod(months = 1)).minus(DatePeriod(days = 1)).dayOfMonth
    return List(42) { index ->
        (index - offset + 1).takeIf { it in 1..days }?.let { LocalDate(first.year, first.monthNumber, it) }
    }
}
